export const sedeRecapitoErrorMessage = "Per specificare la sede di recapito è obbligatorio sia l'indirizzo, sia il Comune, sia il CAP";
export const sedeAmministrativaErrorMessage = "Per specificare la sede amministrativa è obbligatorio sia l'indirizzo, sia il Comune, sia il CAP";
